/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="block-cart-item" :title="product.name" :sub-title="productSku">
    <div class="cart-item">
      <div class="cart-item__media">
        <img-product
        :imgPath="productImage"
        :alt="product.name"
        size="LG"
        />
      </div>
      <div class="cart-item__info">
        <div class="cart-item__info__name d-flex flex-column">
          <span class="title">{{ product.name }}</span>
          <span class="sku">{{ product.sku }}</span>
        </div>
        <div class="cart-item__info__selections">
          <product-selected-options :variants="selectedOptions"></product-selected-options>
        </div>
        <div class="cart-item__info__actions">
          <div class="wrapp-price">
            <span class="product-qty">{{qty}} x </span>
            <div class="price-calculation ml-2">
              <span class="product-price_final mr-2">{{ price | price($store) }}</span>
              <span class="product-price_original" v-show="originalPrice">{{ originalPrice | price($store) }}</span>
            </div>
          </div>
          <div class="wrapp-qty">
            <manage-quantity :minQty="1" :maxQty="maxQty" :currentQty.sync="quantitySelected" :incrementStep="qtyIncremental" ref="updateQty" />
          </div>
        </div>
        <div class="cart-item__info__more-option">
          <div class="wrapp-icon" @click.prevent="$emit('confirm-removal', $vnode.key)">
            <svg class="o-icon"><use xlink:href="#trash"></use></svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from 'theme/modules/notifications'
import { resizeService } from '@/helpers/utils'
import ImgProduct from 'theme/components/Product/Image'
import ManageQuantity from 'theme/components/ManageQuantity/ManageQuantity'
import ProductSelectedOptions from 'theme/components/Product/ProductSelectedOptions'
import Config from 'config'

export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    listIndex: {
      type: Number
    }
  },
  data () {
    return {
      quantitySelected: this.product.qty || 1,
      availabilityError: false
    }
  },
  computed: {
    qtyIncremental () {
      if (this.product && this.product.extension_attributes && this.product.extension_attributes.qty_increment) {
        return this.product.extension_attributes.qty_increment
      } else {
        return 1
      }
    },
    originalPrice () {
      if (this.product && this.product.extension_attributes.product_base_price) {
        // base price is the unitary price
        // check is value using product.price
        let basePrice = this.product.extension_attributes.product_base_price
        let productPrice = this.product.price
        if (productPrice !== basePrice) {
          // show original price as well
          return this.product.extension_attributes.product_base_price
        } else {
          return 0
        }
      }
      return 0
    },
    price () {
      return this.product.price
    },
    qty () {
      return this.product.qty
    },
    maxQty () {
      return this.product && this.product.extension_attributes.salable_qty ? this.product.extension_attributes.salable_qty : 10
    },
    productImage () {
      let imageUrl = this.product && this.product.extension_attributes.image_url
      const { width, height, quality } = Config.Theme.defaultOpt.imageCrop
      if (imageUrl) {
        return `${resizeService(imageUrl)}?crop=true&width=${width}&height=${height}&q=${quality}`
      }
      return ''
    },
    productSku () {
      return this.product && this.product.extension_attributes.sku
    },
    selectedOptions () {
      return this.product && this.product.extension_attributes.selected_options ? this.product.extension_attributes.selected_options : []
    }
  },
  methods: {
    remove () {
      this.$store.commit('ui/showLoader')
      this.$store.dispatch('cart/delete', this.product).finally(() => { this.$store.commit('ui/hideLoader') })
    },
    update (newValue, oldValue) {
      const _this = this
      if (newValue) {
        this.$store.commit('ui/showLoader')
        this.$store.dispatch('cart/update', { qty: newValue, itemId: this.product.item_id, append: false, sku: this.productSku })
          .catch((err) => {
            let message = _this.$t('GenericError')
            let error = err.message
            if (error) {
              message = error
            }
            if (err && err.response && err.response.data && err.response.data.message) {
              message = _this.$t(err.response.data.message)
            }
            _this.availabilityError = true
            _this.quantitySelected = oldValue
            _this.$emit('loading', false)
            toast.error(message)
          })
          .finally(() => {
            this.$store.commit('ui/hideLoader')
          })
      }
    }
  },
  watch: {
    quantitySelected: function (newValue, oldValue) {
      if (!this.availabilityError) {
        this.update(newValue, oldValue)
      } else {
        this.availabilityError = false
      }
    }
  },
  components: {
    ImgProduct,
    ProductSelectedOptions,
    ManageQuantity
  }
}
</script>
